import UsernameLink from '@/features/user/components/UsernameLink';
import routes from '@/routes/routes';
import { getProfilePhoto } from '@/utils/profilePhoto';
import Link from 'next/link';
import {
  isAuctionCharityEditable,
  isAuctionCharityItemContributableToCount,
} from '../../auctionCharity.service';
import CharityAuctionCountdown from '../../components/CharityAuctionCountdown';
import { CharityAuctionShowcaseItemCard } from '../../components/CharityAuctionShowcaseItemCard';
import { AuctionCharityDto } from '../../schedule/auctionCharity.dto';

export const CharityAuctionCard = ({ charityAuction }: { charityAuction: AuctionCharityDto }) => {
  const owner = charityAuction.user;
  const profilePhoto = getProfilePhoto(owner, 'small');
  const banner = owner.profileBanner ?? '/images/checkBackground.png';
  const items = charityAuction.items;
  const itemCount = items.filter(isAuctionCharityItemContributableToCount).length;
  const canEdit = isAuctionCharityEditable(charityAuction);

  return (
    <div className="flex flex-col rounded-lg bg-secondary-darker">
      <div>
        <div className="relative h-[320px]">
          <img
            className="w-full object-cover bg-gray-66 h-full rounded-t-lg"
            src={banner}
            alt="Profile Banner"
          />

          <div className="w-full p-2 absolute bottom-0 bg-shadow-gradient-bottom">
            <div className="flex flex-col gap-y-1 items-start w-full">
              <div className="flex items-center">
                <div className="w-[50px] md:w-[100px] relative">
                  <Link href={routes.showcase({ userId: owner.id })}>
                    <a>
                      <img
                        className="w-full h-full rounded-full border-solid border border-white shadow-xl"
                        src={getProfilePhoto(owner, 'medium')}
                        alt="profilePhoto"
                      />
                    </a>
                  </Link>
                </div>

                <UsernameLink user={owner} textWhite wrapperClass="ml-2" />
              </div>

              <div className="flex flex-row justify-between w-full">
                <h1 className="text-header font-bold text-white truncate">
                  {charityAuction.title}
                </h1>
                <button className="btn btn-new text-white border rounded-full">
                  <Link href={routes.auctions.charity.get(charityAuction.id)}>
                    <a>Join Auction Now</a>
                  </Link>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex flex-col h-[240px]">
        <div className="flex flex-row justify-between my-4 px-4 items-center">
          <div className="flex flex-col">
            <span className="text-xs text-gray-8a">Items</span>
            <span className="text-white text-2xl font-bold">{itemCount}</span>
          </div>
          <CharityAuctionCountdown charityAuction={charityAuction} />
        </div>
        <div className="px-4 overflow-y-auto">
          {items.map((item) => (
            <CharityAuctionShowcaseItemCard
              key={item.id}
              item={item}
              canEdit={canEdit}
              isLink={true}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
